import type { GameProps } from "../pages/Match";
import { Quizduel, Speedrun, Videnraes } from "./SimGames";
import { Skattejagt } from "./SoloGames";
import { Taarn } from "./TaarnGame";
import { Monopoly } from "./MonopolyGame";
import { Fire, Kortkamp, Kryds, Skak, Slagskibe } from "./TurnGames";
import { Ludo, Yatzy } from "./DiceGames";
import { Sudoku, Videnspar } from "./PuzzleGames";
import { VerdenSummary } from "./VerdenSummary";

const MAP: Record<string, (p: GameProps) => any> = { kryds: Kryds, fire: Fire, kortkamp: Kortkamp, slagskibe: Slagskibe, skak: Skak, quizduel: Quizduel, speedrun: Speedrun, videnraes: Videnraes, taarn: Taarn, skattejagt: Skattejagt, monopoly: Monopoly, ludo: Ludo, yatzy: Yatzy, sudoku: Sudoku, videnspar: Videnspar, verden: VerdenSummary };

export function GameView(p: GameProps) {
  const C = MAP[p.view.game];
  return C ? <C {...p} /> : <div className="notice error">Ukendt spil.</div>;
}
